/** Screen geometry is independent of the canvas backing-store resolution. */
export function previewFrame(viewport: { w: number; h: number }, scene: { width: number; height: number }, controls = 132): { width: number; height: number } {
  const availableW = Math.max(1, Math.min(1040, viewport.w - 32));
  const availableH = Math.max(1, viewport.h - controls - 32);
  const aspect = scene.width > 0 && scene.height > 0 ? scene.width / scene.height : 1;
  const width = Math.min(availableW, availableH * aspect);
  return { width: Math.floor(width), height: Math.floor(width / aspect) };
}
